import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide
} from "@mui/material";
import { ReactComponent as ThanksIcon } from "../../assets/thanks.svg";
import useThemeColor from "../../utils/useTheme";
import { forwardRef } from "react";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ThankyouModal = ({ openThanksModal, handleCloseThanksModal, goBack }) => {
  const styles = useThemeColor();
  return (
    <Dialog
      TransitionComponent={Transition}
      TransitionProps={{
        timeout: {
          enter: 500,
          exit: 300
        }
      }}
      sx={{
        ".MuiDialog-paper": {
          background: styles.background,
          padding: 2,
          width: "400px",
          color: styles.color,
          position: "relative"
        }
      }}
      open={openThanksModal}
      onClose={() => {}}
      aria-labelledby="thanks-modal-title"
      aria-describedby="thanks-modal-description"
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        p={2}
      >
        <ThanksIcon />
        <DialogTitle
          id="thanks-modal-title"
          fontSize="30px"
          mb={0}
          fontWeight="500"
        >
          Thank You!
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            color={styles.color}
            fontSize="16px"
            id="thanks-modal-description"
          >
            Your MOD has been submitted.
          </DialogContentText>
          <DialogContentText color={styles.modLabel} fontSize="12px">
            You will receive a badge if your MOD is shared to the community.
          </DialogContentText>
        </DialogContent>
      </Box>
      <DialogActions>
        <Button
          fullWidth
          variant="outlined"
          onClick={() => {
            goBack(false);
            handleCloseThanksModal(false);
          }}
          sx={{
            textTransform: "none",
            color: "#368AD0",
            borderColor: "#368AD0",
            mt: 1, // Reduced margin top
            gap: "8px",
            borderRadius: "4px"
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ThankyouModal;
